import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import SingleChoose from '../../components/Choose';
import Button from '../../components/Button';

import shapeImg from '../../assets/img/about/shape-2-1.png';
import aboutImg from '../../assets/img/about/about-3-1.png';

const About = () => {
  return (
    <div id="it-about" className="it-about-3-area p-relative pt-120 pb-120">
      <div className="it-about-3-shape-1 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 order-1 order-lg-0 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-about-3-left p-relative">
              <div className="it-about-3-experience d-none d-md-flex align-items-center">
                <h6>16+</h6>
                <span>
                  years <br />
                  experience
                </span>
              </div>
              <div className="it-about-3-contact d-none d-md-block text-center">
                <span>Richie Wethington</span>
                <p>
                  Duis aute irure dolor in <br />
                  reprehenderit in voluptate
                </p>
                <div className="it-about-3-ratting">
                  <i className="flaticon-star"></i>
                  <i className="flaticon-star"></i>
                  <i className="flaticon-star"></i>
                  <i className="flaticon-star"></i>
                  <i className="flaticon-star"></i>
                </div>
                <a href="tel:003377756742">
                  <i className="flaticon-phone-call"></i>
                  <span className="hover-anim white">(00) 337-775-6742</span>
                </a>
              </div>
              <div className="it-about-3-thumb">
                <img src={aboutImg} alt="" />
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 order-0 order-lg-1 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-about-3-right">
              <SectionTitle
                itemClass="it-about-3-title-box mb-20"
                subTitleClass="it-section-subtitle tertiary"
                subTitle="More About us"
                titleClass="it-section-title"
                title="Insights Into Vision Exploring Ophthalmology"
              />

              <div className="it-about-3-text mb-30">
                <p>
                  Health and medical is a category that encompasses a wide range
                  topics <br />
                  related to health and wellness category includes medical
                  treatments, preventative care, mental health, fitness
                </p>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-6 mb-20">
                  <SingleChoose
                    itemClass="it-choose-staff style-1 d-flex align-items-center"
                    icon="flaticon-doctor"
                    title="Qualified Doctors"
                    description="Duis aute irure reprehenderit in voluptate velit."
                  />
                </div>
                <div className="col-md-6 col-sm-6 mb-20">
                  <SingleChoose
                    itemClass="it-choose-staff style-2 d-flex align-items-center"
                    icon="flaticon-eye-1"
                    title="Eye Examination"
                    description="Duis aute irure reprehenderit in voluptate velit."
                  />
                </div>
                <div className="col-md-6 col-sm-6">
                  <SingleChoose
                    itemClass="it-choose-staff style-1 d-flex align-items-center"
                    icon="flaticon-contact"
                    title="Contact Lenses"
                    description="Duis aute irure reprehenderit in voluptate velit."
                  />
                </div>
                <div className="col-md-6 col-sm-6">
                  <SingleChoose
                    itemClass="it-choose-staff style-2 d-flex align-items-center"
                    icon="flaticon-eye-surgery"
                    title="Eye Correction"
                    description="Duis aute irure reprehenderit in voluptate velit."
                  />
                </div>
              </div>
              <div className="it-about-3-button mt-30">
                <Link to="/appointment" className="it-btn-theme tertiary-bg">
                  <Button btnText="Book an appointment" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
